import { memo, ReactNode, useMemo } from 'react';

import { LinkButton } from '@atlaskit/button/new';

import { ORIGIN } from '../constants';

export interface Props {
  children?: ReactNode;
  className?: string;
  href: string;
  buttonProps?: any;
}

const ExternalLink = ({ children, className, href, buttonProps }: Props) => {
  const target = useMemo(
    () => (href.indexOf(ORIGIN) === -1 ? '_blank' : '_top'),
    [href]
  );

  return buttonProps ? (
    <LinkButton href={href} target={target} {...buttonProps}>
      {children}
    </LinkButton>
  ) : (
    <a
      href={href}
      target={target}
      rel="noopener noreferrer"
      {...(className ? { className } : '')}
    >
      {children}
    </a>
  );
};

// eslint-disable-next-line import/no-default-export
export default memo(ExternalLink);
